import PaginationTwo from "./PaginationTwo";

export default PaginationTwo;
